const token = localStorage.getItem('cpcToken');

export default {
  loggedIn: !!token,
  currentUser: null
};
